export var chunk = function (array, chunkSize) {
    var chunks = [];
    var i = 0;
    var n = array.length;
    while (i < n) {
        chunks.push(array.slice(i, i += chunkSize));
    }
    return chunks;
};
